<div class="container">
  <ng-container *ngFor="let item of items">
    <div class="item-container">
      <div class="big-button-icon mat-elevation-z1 border-radius" [routerLink]="item.link">
        <div>
          <mat-icon color="primary">{{ item.icon }}</mat-icon>
        </div>
        <div class="explainer">
          <h3>{{ item.title }}</h3>
          <p>{{ item.subtitle }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
